var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ReportingCard',{attrs:{"title":"Posting Activity"}},[_c('RChartArea',{attrs:{"series":_vm.series,"options":_vm.chartOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }